export const FILTER_RANGES = [
  ["minPrice", "maxPrice", "precio"],
  ["minRooms", "maxRooms", "ambientes"],
  ["minBedrooms", "maxBedrooms", "dormitorios"],
  ["minBathrooms", "maxBathrooms", "baños"],
  ["minAntiquity", "maxAntiquity", "antigüedad"],
  ["minSquareMetersCovered", "maxSquareMetersCovered", "m² cubiertos"],
  ["minSquareMetersTotal", "maxSquareMetersTotal", "m² totales"],
];

/** Filtros de superficie: aceptan decimales en la búsqueda. */
export const DECIMAL_FILTER_KEYS = new Set([
  "minSquareMetersCovered",
  "maxSquareMetersCovered",
  "minSquareMetersTotal",
  "maxSquareMetersTotal",
]);

export const FILTER_INPUT_LABELS = Object.fromEntries(
  FILTER_RANGES.flatMap(([min, max, label]) => [[min, `Mínimo de ${label}`], [max, `Máximo de ${label}`]]),
);
FILTER_INPUT_LABELS.minParking = "Mínimo de cocheras";

export function validateFilterDraft(filters) {
  const present = value => value !== null && value !== undefined && value !== "";
  for (const key of Object.keys(FILTER_INPUT_LABELS)) {
    const value = filters[key];
    if (!present(value)) continue;
    const n = Number(value);
    if (!Number.isFinite(n) || n < 0) {
      return "Ingresá valores mayores o iguales a cero.";
    }
    if (!DECIMAL_FILTER_KEYS.has(key) && !Number.isSafeInteger(n)) {
      return "Ingresá valores enteros mayores o iguales a cero.";
    }
  }
  for (const [min, max, label] of FILTER_RANGES) {
    if (present(filters[min]) && present(filters[max]) && Number(filters[min]) > Number(filters[max])) {
      return `El mínimo de ${label} no puede superar el máximo.`;
    }
  }
  return null;
}
